import '@angular/compiler';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PageChecklistComponent } from './page.checklist/page.checklist.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PageChecklistFacilitiesComponent } from './page.checklist.facilities/page.checklist.facilities.component';
import { PageInspectionComponent } from './page.inspection/page.inspection.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageInspectionViewerComponent } from './page.inspection.viewer/page.inspection.viewer.component';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentAuthLoginComponent } from './component.auth.login/component.auth.login.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PageProjectDetailComponent } from './page.project.detail/page.project.detail.component';
import { ComponentProjectFacilitiesComponent } from './component.project.facilities/component.project.facilities.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { LayoutFieldComponent } from './layout.field/layout.field.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentMainOverviewComponent } from './component.main.overview/component.main.overview.component';
import { PageReleaseDiagnosticsComponent } from './page.release.diagnostics/page.release.diagnostics.component';
import { ComponentProjectDrawingAddComponent } from './component.project.drawing.add/component.project.drawing.add.component';
import { ComponentProjectFacilityAddComponent } from './component.project.facility.add/component.project.facility.add.component';
import { ComponentMainProjectAddComponent } from './component.main.project.add/component.main.project.add.component';
import { ComponentAuthRegisterComponent } from './component.auth.register/component.auth.register.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { ComponentProjectDrawingsComponent } from './component.project.drawings/component.project.drawings.component';
import { PageChecklistRespondComponent } from './page.checklist.respond/page.checklist.respond.component';
import { ComponentAuthForgotComponent } from './component.auth.forgot/component.auth.forgot.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentMainProjectsComponent } from './component.main.projects/component.main.projects.component';
import { PageProjectListComponent } from './page.project.list/page.project.list.component';
import { PageChecklistResultComponent } from './page.checklist.result/page.checklist.result.component';

const INDEX_PAGE = "login";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutFieldComponent,
        "children": [
            {
                "path": "checklist",
                component: PageChecklistComponent,
                "app_id": "page.checklist"
            },
            {
                "path": "checklist/project/:projectId",
                component: PageChecklistFacilitiesComponent,
                "app_id": "page.checklist.facilities"
            },
            {
                "path": "inspection",
                component: PageInspectionComponent,
                "app_id": "page.inspection"
            },
            {
                "path": "home",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "checklist/respond/:responseId",
                component: PageChecklistRespondComponent,
                "app_id": "page.checklist.respond"
            },
            {
                "path": "checklist/result/:responseId",
                component: PageChecklistResultComponent,
                "app_id": "page.checklist.result"
            }
        ]
    },
    {
        component: LayoutNavbarComponent,
        "children": [
            {
                "path": "inspection/facility/:facilityId/drawing/:drawingId",
                component: PageInspectionViewerComponent,
                "app_id": "page.inspection.viewer"
            },
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "project/detail/:id",
                component: PageProjectDetailComponent,
                "app_id": "page.project.detail"
            },
            {
                "path": "release/diagnostics",
                component: PageReleaseDiagnosticsComponent,
                "app_id": "page.release.diagnostics"
            },
            {
                "path": "project/list",
                component: PageProjectListComponent,
                "app_id": "page.project.list"
            }
        ]
    },
    {
        component: LayoutAuthComponent,
        "children": [
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }